exports.onClientEntry = () => {
  window._axcb = window._axcb ?? []

  window._axcb.push(sdk => {
    sdk.on("consent:saved", () => {
      window.location.reload()
    })
  })
}
